import CategoryListing from "./CategoryListing";

export default CategoryListing;